import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

function TabsSkeleton({ langLocal }) {
    return (
        <>
            {[1].map((index) => {
                return (
                    <div style={{ display: "flex", alignItems: "center", margin: "0px 20px" }} >
                        <div style={{
                            width: "10%", height: '45px',
                            margin: `${langLocal === 'ar' ? "0px 0px 0px 15px" : "0px 15px 0px 0px"}`
                        }}>
                            <Skeleton width='100%' height='100%' borderRadius={5} />
                        </div>
                        <div style={{ width: "10%", height: '45px' }}>
                            <Skeleton width='100%' height='100%' borderRadius={5} />
                        </div>
                    </div>
                )
            })}
        </>
    )
}

export default TabsSkeleton

